import { render, staticRenderFns } from "./AboutLinks.vue?vue&type=template&id=1132dd3f&"
import script from "./AboutLinks.vue?vue&type=script&lang=js&"
export * from "./AboutLinks.vue?vue&type=script&lang=js&"
import style0 from "./AboutLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports